import type { ClientAccuracy, ConversionRecord } from '../types';
import type { WorkItem } from './workItems';

/**
 * The client's dashboard, as numbers (Christian's walk of deploy #20: Overview was a placeholder status box). Every
 * figure is read off the client's Work (`deriveWorkItems`), so the dashboard and the Work tab can never disagree.
 */
export interface OverviewCounts {
  /** Sources uploaded that no journal uses yet: DR-15 returns and POS reports waiting for a journal. */
  toJournal: number;
  /** Journals built but not exported: drafts and proposals. */
  awaitingExport: number;
  /** Exported journals nobody has confirmed landed in Xero. */
  awaitingConfirmation: number;
}

export function overviewCounts(items: WorkItem[]): OverviewCounts {
  const count = (status: WorkItem['status']) => items.filter((i) => i.status === status).length;
  return {
    toJournal: count('uploaded'),
    awaitingExport: count('draft') + count('proposed'),
    awaitingConfirmation: count('unconfirmed'),
  };
}

/** The newest bank file produced for this client (either Xero shape), or null when there has been none. */
export function lastBankFile(conversions: ConversionRecord[]): ConversionRecord | null {
  return conversions
    .filter((c) => c.flow !== 'manualJournal')
    .reduce<ConversionRecord | null>((newest, c) => (!newest || c.generatedAt > newest.generatedAt ? c : newest), null);
}

/** This client's DR-15 streak row from the accuracy report, or null when it has no graded pair yet. */
export function clientStreak(rows: ClientAccuracy[] | undefined, clientId: string): ClientAccuracy | null {
  return rows?.find((r) => r.clientId.toLowerCase() === clientId.toLowerCase() && r.sourceKind === 'dr15') ?? null;
}
